import React from 'react';
import './FeaturedCallSection.css';

import { eventTypes, trackEvent } from '../../helpers/AnalyticsManager';
import BorderedButton from '../../common/borderedButton/BorderedButton';

const FeaturedCallSection = () => (
  <div className="featured-call">
    <h2>Let&apos;s innovate together!</h2>
    <BorderedButton
      monoMode
      id="contact-button"
      title="Contato"
      redirect="/contact"
      centered
      beforeAction={() => trackEvent(eventTypes.industryContact)}
    />
  </div>
);

export default FeaturedCallSection;
